import TextWithImageLeft3 from './TextWithImageLeft3';

export default TextWithImageLeft3;